import React from 'react';
import { Box, Button } from 'fw/components'
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Col, Row } from "react-bootstrap";
import * as App from 'modules/app/App'
import DiscountCategorySummary from './discountCategorySummary/DiscountCategorySummary';
import DiscountCodeGenerationPopUp from '../../../admin/discountCodeSetup/discountCodeGeneration/DiscountCodeGenerationPopUp'; // TODO: Review this import
import SponsorTypeSummary from './sponsorTypeSummary/SponsorTypeSummary';
import OpenCertifications from './openCertifications/OpenCertifications';

class AdminDiscountCodeDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = () => {
		return {};
	}

	onDiscountCodeSetupClick = () => {
		this.props.history.push('/admin/discountCodeSetup');
    }

	onGenerateDiscountCodePopUpClose = (success) => {
		let me = this;

		this.setState({
            showGenerateDiscountCodePopUp: false
        }, () => { if (success === true) { 
			me._sponsorTypeSummary.get();
			me._discountCategorySummary.get();
			me._openCertifications.search();
		} });
    }

    onGenerateDiscountCodeClick = () => {
        this.setState({
            showGenerateDiscountCodePopUp: true
        });
    }

	render() {
		return (
			App.hasPrivilege("AdminDiscountCodeDashboardAccess") ?
				<React.Fragment>
					<ContentHeader title={"Dashboard – "} description={"Discount Review"}>
					</ContentHeader>
					<ContentBody>
						<Box>
							<Row>
								<Col md={4}>
									<ContentHeader title={"Discount Category Summary"} />
									<ContentBody>
									 	<DiscountCategorySummary ref={(c) => { this._discountCategorySummary = c }} />
									</ContentBody>
									</Col>
								<Col md={5}>
									<ContentHeader title={"Sponsor Type Summary"} />
									<ContentBody>
										<SponsorTypeSummary ref={(c) => { this._sponsorTypeSummary = c }} />
									</ContentBody>
								</Col>
								<Col md={3}>
									<Button style={{marginLeft:"15px"}} id='btnGenerateDiscountCodePopUp' onClick={this.onGenerateDiscountCodeClick} bsClass="btn btn-success" className="pull-right">
										Generate Discount Code
									</Button>
									{<DiscountCodeGenerationPopUp
										visible={this.state.showGenerateDiscountCodePopUp}
										onClose={this.onGenerateDiscountCodePopUpClose}
									/>}
									<Button
										id="btnDiscountCodeSetup"
										onClick={this.onDiscountCodeSetupClick}
										bsStyle="primary"
										className="pull-right">
										Discount Code Search
									</Button>
									
								</Col>
							</Row>
							<Row>
								<Col md={12}>
									<ContentHeader title={"Open Applications"}>
									</ContentHeader>
									<ContentBody>
										<OpenCertifications ref={(c) => { this._openCertifications = c }} />
									</ContentBody>
								</Col>
							</Row>
						</Box>
					</ContentBody>
				</React.Fragment >
				: null
		)
	}
}

export default AdminDiscountCodeDashboard;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDiscountCodeDashboard/AdminDiscountCodeDashboard.js